import { FC } from 'react'
import { AriaCalendarGridProps, useCalendarGrid } from '@react-aria/calendar'
import { CalendarDate, getWeeksInMonth, isSameDay, startOfWeek } from '@internationalized/date'
import { useLocale } from '@react-aria/i18n'
import { CalendarCell } from 'components/atoms/inputs/DatePicker/Calendar/CalendarCell'
import { CalendarState } from '@react-stately/calendar'

type CalendarGrid =
  & AriaCalendarGridProps
  & {
    highlightedDates?: CalendarDate[]
    state: CalendarState
  }

export const CalendarGrid: FC<CalendarGrid> = ({ state, highlightedDates, ...props }) => {
  const { locale } = useLocale()
  const { gridProps, headerProps, weekDays } = useCalendarGrid(props, state)

  const monthStart = startOfWeek(state.visibleRange.start, locale)
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale)
  const weeksInMonthArray = new Array(weeksInMonth).fill(null).map((_, idx) => idx)
  const dayIndexArray = new Array(7).fill(null).map((_, idx) => idx)

  return (
    <table { ...gridProps } cellSpacing={ 0 } >
      <thead { ...headerProps }>
        <tr>
          {weekDays.map((day, index) => <th key={ index }>{day}</th>)}
        </tr>
      </thead>
      <tbody>
        {weeksInMonthArray.map((weekIndex) => (
          <tr key={ weekIndex }>
            {
              dayIndexArray.map((dayIndex) => {
                const date = monthStart.add({ weeks: weekIndex, days: dayIndex })
                const isHighlighted = !!highlightedDates?.find((highlightedDate) => isSameDay(highlightedDate, date))
                return (
                  <CalendarCell
                    key={ dayIndex }
                    state={ state }
                    date={ date }
                    isHighlighted={ isHighlighted }
                  />
                )
              })
            }
          </tr>
        ))}
      </tbody>
    </table>
  )
}
